/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowreviewmissing3Inputs */

const en_aiflowreviewmissing3 = /** @type {(inputs: Aiflowreviewmissing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`still missing`)
};

const de_aiflowreviewmissing3 = /** @type {(inputs: Aiflowreviewmissing3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fehlt noch`)
};

/**
* | output |
* | --- |
* | "still missing" |
*
* @param {Aiflowreviewmissing3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowreviewmissing3 = /** @type {((inputs?: Aiflowreviewmissing3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowreviewmissing3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowreviewmissing3(inputs)
	return de_aiflowreviewmissing3(inputs)
});
export { aiflowreviewmissing3 as "aiFlowReviewMissing" }